module.exports = __webpack_public_path__ + "img/flyer_utra_roadhog4.17bac4cd.jpg";